var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h2', [_vm._v("我的答卷")]), _c('a-divider'), _c('a-button', {
    attrs: {
      "type": "danger",
      "icon": "left-circle"
    },
    on: {
      "click": function click($event) {
        return _vm.toMyPaper();
      }
    }
  }, [_vm._v("返回我的考试")]), _c('br'), _c('br'), _c('a-table', {
    ref: "table",
    attrs: {
      "bordered": "",
      "size": "middle",
      "rowKey": "id",
      "columns": _vm.columns,
      "dataSource": _vm.dataSource,
      "pagination": _vm.ipagination,
      "loading": _vm.loading
    },
    on: {
      "change": _vm.handleTableChange
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function fn(text, record) {
        return _c('span', {}, [_c('a', {
          on: {
            "click": function click($event) {
              return _vm.handleReview(record);
            }
          }
        }, [_vm._v("查看试卷")])]);
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };